import {useEffect, useState} from "react";
import plansData from "../../_dummydata/plansData.json";
import RadioButton from "../Atoms/RadioButton.js";
import {connect} from "react-redux";
import {handleUpdateOrderSubscription} from "../../actions/ordersubscription";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
    handleUpdateOrderSubscription,
  }
)((props, {}) => {
  let i18n = props.i18n;
  const plans = plansData.plans;
  const {planTitle} = props.orderSubscription;
  const [title, setTitle] = useState(planTitle);
  const {cost} = props.orderSubscription;
  // Initialize state with an array of false values
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(1);

  const handleRadioChange = (index, title, cost) => {
    setSelectedPlanIndex(index);
    props.handleUpdateOrderSubscription({planTitle: title, cost: cost});
  };

  useEffect(() => {
    if (plans && plans.length > 0) {
      props.handleUpdateOrderSubscription({
        planTitle: plans[1].title.de,
        cost: plans[1].cost[0].value, // Dynamically set the cost from plans data
      });
    }
  }, []);

  return (
    <div className="item-list">
      {plans.map((plan, index) => (
        
        <div className="item" key={index}>
          <div className="item-title">
            <RadioButton
              checked={selectedPlanIndex === index}
              onChange={() =>
                handleRadioChange(index, plan.title.de, plan.cost[0].value)
              }
              value={index}
              label=""
            />
            <h3>{plan.title.de}</h3>
            <p>
              {plan.cost[0].value} {plan.cost[0].unit.displayname.de} pro{" "}
              {plan.cost[0].per.unit.displayname.de}
            </p>
          </div>
          <p className="item-text">{plan.description.de}</p>
        </div>
      ))}
    </div>
  );
});
